/* eslint-disable react/jsx-pascal-case */
/* Original name @uswitch/trustyle.tble */

import { Themed } from 'theme-ui'

const Table = ({ children, ...props }) => {
  return (
    <div
      sx={{
        overflowX: ['scroll', 'visible', 'visible'],
        '&::-webkit-scrollbar': { display: 'none' },
        '&::-ms-overflow-style': { display: 'none' },
      }}
    >
      <Themed.table {...props}>{children}</Themed.table>
    </div>
  )
}

const TableRow = ({ children, ...props }) => {
  return <Themed.tr {...props}>{children}</Themed.tr>
}

const TableCell = ({ children, ...props }) => {
  return <Themed.td {...props}>{children}</Themed.td>
}

const TableHeaderCell = ({ children, ...props }) => {
  return <Themed.th {...props}>{children}</Themed.th>
}

export default {
  wrap: Table,
  td: TableCell,
  tr: TableRow,
  th: TableHeaderCell,
}
